import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { toast } from '@hivebrite/design-system/Toast';

import { type RelatedNewsItem } from 'hb-react/shared/apps/News/types';

import { getRelatedNewsRequest } from '../requests/getRelatedNewsRequest';

interface UseQueryRelatedNewsProps {
  enabled: boolean;
  newsId?: string;
  topicId?: number;
  userId?: number;
  whiteLabelTopic?: boolean;
}

export const useQueryRelatedNews = ({
  enabled,
  userId,
  topicId,
  newsId,
  whiteLabelTopic,
}: UseQueryRelatedNewsProps): {
  data: Array<RelatedNewsItem>;
  isLoading: boolean;
  refetch: () => void;
} => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['relatedNews', newsId],
    enabled: enabled && !!newsId,
    queryFn: async ({ signal }) => {
      try {
        const {
          data: { data: relatedNews },
        } = await getRelatedNewsRequest({
          userId,
          topicId,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          newsId: newsId!,
          signal,
          whiteLabelTopic,
        });

        return relatedNews;
      } catch (error) {
        toast.error(__('Sorry, an error occurred'));
        throw error;
      }
    },
    staleTime: ms('5m'),
  });

  return {
    data: data || [],
    isLoading,
    refetch,
  };
};
